<template>
  <div class="my-dropdown">
    <span class="title">{{ $t(title) }}：</span>
    <el-dropdown v-bind="$attrs" @command="handleCommand">
      <span class="el-dropdown-link">
        {{ vLable }}<i class="el-icon-caret-bottom el-icon--right" />
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item v-for="item in list" :key="item.value" :command="item.value">{{ $t(item.label) }}</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: null,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: 'common.select'
    },
    list: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {

    }
  },
  computed: {
    label() {
      if (!this.value) return ''
      const vList = this.list.filter(i => i.value === this.value)[0]
      return vList && vList.label
    },
    vLable() {
      return this.value
        ? this.$t(this.label) || this.value
        : this.$t(this.placeholder)
    }
  },
  methods: {
    handleCommand(command) {
      this.$emit('input', command)
    }
  }
}
</script>

<style lang="scss" scoped>
$font-size--normal: 12px;
.my-dropdown {
    font-size: $font-size--normal;
    color: #52555D;
    .title{
        margin-right: 5px;
    }
    /deep/ {
        .el-dropdown-link{
            font-size: $font-size--normal
        }
    }
}
</style>
